import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import DriverDetail from './DriverDetail';
import { getVehicleById, getAccountDetails } from '../../api/vehicalsManagementApi';

const VehicleDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const navigateRef = useRef(navigate);
  const locationRef = useRef(location);
  const [vehicle, setVehicle] = useState(null);
  const [loading, setLoading] = useState(true);

  // Keep refs up to date without adding to effect deps
  useEffect(() => { navigateRef.current = navigate; }, [navigate]);
  useEffect(() => { locationRef.current = location; }, [location]);

  const navigateBackToVehicles = () => {
    const fromPage = locationRef.current?.state?.fromPage || sessionStorage.getItem('vehicles_page');
    if (fromPage && Number(fromPage) > 1) {
      navigateRef.current(`/vehicles?page=${fromPage}`, { state: { fromPage } });
    } else {
      navigateRef.current('/vehicles');
    }
  };

  useEffect(() => {
    if (!id) {
      navigateBackToVehicles();
      return;
    }

    let cancelled = false;

    const fetchVehicleData = async () => {
      try {
        setLoading(true);
        const vehicleResponse = await getVehicleById(id);

        if (cancelled) return;

        if (vehicleResponse.success && vehicleResponse.data) {
          let vehicleData = vehicleResponse.data;

          // Fetch account/bank details by vehicle ID
          try {
            const accountResponse = await getAccountDetails(id);
            if (!cancelled && accountResponse.success && accountResponse.data) {
              const accountDetails = accountResponse.data; // single object from /by-vehicle/
              vehicleData = {
                ...vehicleData,
                accountDetailsId: accountDetails.id,
                accountHolderName: accountDetails.accountHolderName,
                accountNumber: accountDetails.accountNumber,
                bankName: accountDetails.bankName,
                bankCategory: accountDetails.bankCategory,
                ifscCode: accountDetails.ifscCode,
                branch: accountDetails.branch,
              };
            }
          } catch (accountErr) {
            // 404 = no bank details yet, continue without them
          }

          if (!cancelled) setVehicle(vehicleData);
        } else {
          if (!cancelled) navigateBackToVehicles();
        }
      } catch (err) {
        if (!cancelled) navigateBackToVehicles();
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchVehicleData();

    // Cleanup: prevent state updates if component unmounts or id changes
    return () => { cancelled = true; };
  }, [id]); // Only re-run when the vehicle ID in the URL changes

  const handleBack = () => navigateBackToVehicles();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '16px',
        color: '#666'
      }}>
        Loading vehicle details...
      </div>
    );
  }

  if (!vehicle) return null;

  return <DriverDetail driver={vehicle} vehicle={vehicle} onBack={handleBack} />;
};

export default VehicleDetailPage;
